export default __webpack_public_path__ + "static/thumb-9-57878fe5560ee83f52700aa4ab3ef835.jpg";